"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.abort = void 0;
var iquery_1 = require("@dustess/iquery");
// 企微可以替换成企微端的URL
var VUE_APP_PC_B_BASE_URL = (window && window.envConfig).VUE_APP_PC_B_BASE_URL;
console.log('VUE_APP_PC_B_BASE_URL: ', VUE_APP_PC_B_BASE_URL);
var _a = (0, iquery_1.createAxios)({
    baseURL: VUE_APP_PC_B_BASE_URL,
}), ajax = _a.ajax, abort = _a.abort, request = _a.request;
exports.abort = abort;
exports.request = request;
(0, iquery_1.interceptorsResponse)('NoAccess', function (response) {
    response.data.xCfAccId = response.headers['X-Cf-Accid'] || response.headers['x-cf-accid'];
});
var check = function (value, name) {
    if (value === null || value === undefined) {
        var msg = "[ERROR PARAMS]: ".concat(name, " can't be null or undefined");
        // 非生产环境，直接抛出错误
        // if (process.env.NODE_ENV === 'development') {
        // }
        throw Error(msg);
    }
};
var wrappedFetch = {
    ajax: ajax,
    check: check,
    abort: abort,
    request: request,
};
__exportStar(require("@dustess/iquery"), exports);
exports.default = wrappedFetch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYWpheC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDBDQUV5QjtBQUN6QixpQkFBaUI7QUFDVCxJQUFBLHFCQUFxQixHQUFLLENBQUEsTUFBTSxJQUFJLE1BQU0sQ0FBQyxTQUFTLENBQUEsc0JBQS9CLENBQWdDO0FBQzdELE9BQU8sQ0FBQyxHQUFHLENBQUMseUJBQXlCLEVBQUUscUJBQXFCLENBQUMsQ0FBQztBQUV4RCxJQUFBLEtBRUYsSUFBQSxvQkFBVyxFQUFDO0lBQ2QsT0FBTyxFQUFFLHFCQUFxQjtDQUMvQixDQUFDLEVBSEEsSUFBSSxVQUFBLEVBQUUsS0FBSyxXQUFBLEVBQUUsT0FBTyxhQUdwQixDQUFDO0FBNEJELHNCQUFLO0FBQUUsMEJBQU87QUExQmhCLElBQUEsNkJBQW9CLEVBQUMsVUFBVSxFQUFFLFVBQUMsUUFBUTtJQUN4QyxRQUFRLENBQUMsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxJQUFJLFFBQVEsQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLENBQUM7QUFDNUYsQ0FBQyxDQUFDLENBQUM7QUFFSCxJQUFNLEtBQUssR0FBRyxVQUFLLEtBQVEsRUFBRSxJQUFZO0lBQ3ZDLElBQUksS0FBSyxLQUFLLElBQUksSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3pDLElBQU0sR0FBRyxHQUFHLDBCQUFtQixJQUFJLGdDQUE2QixDQUFDO1FBQ2pFLGVBQWU7UUFDZixnREFBZ0Q7UUFDaEQsSUFBSTtRQUNKLE1BQU0sS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0tBQ2xCO0FBQ0gsQ0FBQyxDQUFDO0FBRUYsSUFBTSxZQUFZLEdBQUc7SUFDbkIsSUFBSSxNQUFBO0lBQ0osS0FBSyxPQUFBO0lBQ0wsS0FBSyxPQUFBO0lBQ0wsT0FBTyxTQUFBO0NBQ1IsQ0FBQztBQUVGLGtEQUFnQztBQUVoQyxrQkFBZSxZQUFZLENBQUMifQ==